import { useQuery } from '@tanstack/react-query';
import { REACT_QUERY_GET_DASHBOARD_ANALYTICS } from '../constants';
import analyticsUseCase from '../factories/dashboardAnalytics';

export const useGetDashboardAnalytics = (variables = {}, options = {}) => {
  const query = useQuery({
    queryKey: [REACT_QUERY_GET_DASHBOARD_ANALYTICS, variables],
    queryFn: () => analyticsUseCase.getDashboardAnalytics(variables),
    ...options,
  });

  return query;
};
